<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-11-21 13:59:06
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-09 13:49:34
 * @FilePath: \seller.sviptrader.com\src\views\teamManage\accountManage\components\deactivate\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" width="400px" :before-close="handClose">
		<div slot="title">
			提示
		</div>
		<div class="flex-row-align-center">
			<i class="el-icon-warning mr-6 font-h2-regular" style="color: #ff7038"></i>
			<span class="ft-14">是否确认解绑该微信？</span>
		</div>
		<p class="ml-24 mt-6" v-if="bindLength === 1">解绑后，账号登录时需重新进行微信绑定。</p>
		<span slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="submit">确 认</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { wxUnbind } from '@/api/teamManage';
export default {
	data() {
		return {
			visible: false,
			id: '',
			isEnable: true,
			bindId: '',
			bindLength: 0,
		};
	},
	methods: {
		show(id, bindId, bindLength) {
			this.bindLength = bindLength;
			this.id = id;
			this.bindId = bindId;
			this.visible = true;
		},
		async submit() {
			//删除接口
			const { id: userId, bindId } = this;
			await wxUnbind({ userId, bindId });
			this.$message.success('操作成功！');
			this.$emit('Refresh');
			this.handClose();
		},
		handClose() {
			this.bindLength = 0;
			this.visible = false;
		},
	},
};
</script>
<style lang="'less'" scoped></style>
